/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorFacebook from 'base/components/labrador/Facebook';

export const DynamicLabradorFacebook: typeof LabradorFacebook = (props) => {
    return <ErrorBoundary><LabradorFacebook {...props} /></ErrorBoundary>;
}
export type DynamicLabradorFacebookProps = PropsFromComponent<typeof LabradorFacebook>;
